// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuietModeScheduler_list__xjyzG {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.QuietModeScheduler_list-item-container__sn6x0 {
  width: 100%;
  max-width: 40rem;
}

.QuietModeScheduler_add-button__fYwta {
  display: flex;
  height: 3rem;
  width: 100%;
  max-width: 40rem;
  background: #f2f2f2;
  justify-content: center;
  align-items: center;
}
.QuietModeScheduler_add-button__fYwta img {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}

.QuietModeScheduler_add-button__fYwta:hover:enabled {
  background: #eeeeee;
}

.QuietModeScheduler_add-button__fYwta:disabled {
  background: #f2f2f2;
}

.QuietModeScheduler_header__EFy0I {
  display: flex;
  width: 100%;
  padding-top: 0.5rem;
}

.QuietModeScheduler_timezone__5FG4F {
  margin-left: auto;
}

.QuietModeScheduler_row__1WTRl {
  margin-top: 2rem;
  display: flex;
  align-items: center;
  min-height: 2rem;
}

.QuietModeScheduler_text__g79Co {
  flex: 1 1;
  margin-bottom: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/NodeInfo/QuietModeScheduler.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EAEA,uBAAA;EACA,mBAAA;AAAF;AAEE;EACE,WAAA;EACA,YAAA;EACA,oBAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,WAAA;EACA,mBAAA;AADF;;AAIA;EACE,iBAAA;AADF;;AAIA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AADF;;AAIA;EACE,SAAA;EACA,gBAAA;AADF","sourcesContent":[".list {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.list-item-container {\n  width: 100%;\n  max-width: 40rem;\n}\n\n.add-button {\n  display: flex;\n  height: 3rem;\n  width: 100%;\n  max-width: 40rem;\n  background: #f2f2f2;\n  justify-content: center;\n  align-items: center;\n}\n.add-button img {\n  width: 2rem;\n  height: 2rem;\n  margin-right: 0.5rem;\n}\n\n.add-button:hover:enabled {\n  background: #eeeeee;\n}\n\n.add-button:disabled {\n  background: #f2f2f2;\n}\n\n.header {\n  display: flex;\n  width: 100%;\n  padding-top: 0.5rem;\n}\n\n.timezone {\n  margin-left: auto;\n}\n\n.row {\n  margin-top: 2rem;\n  display: flex;\n  align-items: center;\n  min-height: 2rem;\n}\n\n.text {\n  flex: 1;\n  margin-bottom: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": `QuietModeScheduler_list__xjyzG`,
	"list-item-container": `QuietModeScheduler_list-item-container__sn6x0`,
	"add-button": `QuietModeScheduler_add-button__fYwta`,
	"header": `QuietModeScheduler_header__EFy0I`,
	"timezone": `QuietModeScheduler_timezone__5FG4F`,
	"row": `QuietModeScheduler_row__1WTRl`,
	"text": `QuietModeScheduler_text__g79Co`
};
export default ___CSS_LOADER_EXPORT___;
